/**
 * @desc 下载沃尔玛库存结余报告
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.platDataFlow.platformReport.createAndGetWFSRealTimeInventoryReport.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/platformReport/createAndGetWFSRealTimeInventoryReport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
